module.exports = __webpack_public_path__ + "static/img/user.82ce3c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 1